export default "__VITE_ASSET__BjCCdEaF__"